/**
 * The appearance preferences (theme and density) as React state.
 *
 * A thin subscription over src/lib/theme.js, which owns the storage and the
 * DOM attributes; every component reading this re-renders together when the
 * theme changes, including when the OS flips it under a 'system' preference.
 */
import { useSyncExternalStore } from 'react';
import {
  getDensity,
  getResolvedTheme,
  getThemePreference,
  setDensity,
  setThemePreference,
  subscribeAppearance,
} from '../lib/theme.js';

export function useAppearance() {
  const preference = useSyncExternalStore(subscribeAppearance, getThemePreference);
  const resolved = useSyncExternalStore(subscribeAppearance, getResolvedTheme);
  const density = useSyncExternalStore(subscribeAppearance, getDensity);

  return { preference, resolved, density, setTheme: setThemePreference, setDensity };
}
